<template>
    <v-dialog v-model="dialogControl">
        <v-card class="center">
            <v-btn @click="dialogControl = false" class="top-right-close-btn" icon>
                <v-icon>fas fa-times</v-icon>
            </v-btn>
            <v-row class="center py-10">
                <h2>Advertisement Interest Actions</h2>
            </v-row>
            <v-row class="px-5">
                <v-col>
                    <v-row class="center me-6">
                        <v-btn-toggle background-color="secondary-icon" @change="reset" v-model="chosenAction" borderless>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="companySiteEnum">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon">fas fa-link</v-icon>
                                    </v-btn>
                                </template>
                                <span>Link To Company Site</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="extSiteLink">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon">fas fa-external-link-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>Link To External Site</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="textEnum">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon">fas fa-sms</v-icon>
                                    </v-btn>
                                </template>
                                <span>SMS Signup</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="couponEnum">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon">fas fa-envelope</v-icon>
                                    </v-btn>
                                </template>
                                <span>Coupon</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </v-row>
                </v-col>
                <v-col>
                    <v-text-field v-show="chosenAction === extSiteLink" outlined label="Url" ref="url" :rules="urlStringRules" v-model="actionInput"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="center">
                <site-button
                    v-if="canSubmit"
                    :colNum="9"
                    :marginNumber="3"
                    @click-event="submitInterests"
                    iconString="fas fa-mail-bulk"
                    btnType="text"
                    text="Submit Branding Request"
                    colorClasses="secondary-icon"
                    iconColor="primary-icon"
                ></site-button>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<style scoped>
::v-deep .v-dialog{
    overflow-y: hidden !important;
    border-radius: 15px;
    max-height: 70% !important;
    max-width: 65%;
}
</style>

<script>
import LinkTypes from '../../assets/Enums/LinkType';
import utils from '../../utilities/utils';
import SiteButton from './SiteButton.vue';
import { mask } from 'vue-the-mask'

export default {
    directives: {
        mask,
    },
    components: {
        "site-button": SiteButton
    },
    props: {
        action: String,
        input: String,
        showDialog: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        chosenAction: LinkTypes.None,
        actionInput: '',
    }),
    created(){
        this.chosenAction = this.action;
        this.actionInput = this.input;
    },
    methods: {
        reset(){
            this.actionInput = ''
            this.$refs.url.reset();
        },
        submitInterests(){
            this.dialogControl = false;
            this.$emit('submit-interests', this.$data);
        }
    },
    computed: {
        dialogControl: {
            get() {
                return this.showDialog;
            },
            set(newVal) {
                this.$emit('set-dialog-control', newVal);
            },
        },
        isMobile() {
            return screen.width <= 760;
        },
        emailStringRules() {
            return [
                v => !!v || 'Please enter an email address',
                v => utils.testEmailValidity(v) || 'Please enter a valid email address'
            ]
        },
        urlStringRules() {
            return [
                v => !!v || 'Please enter a url address',
                v => utils.isValidUrl(v) || 'Please enter a valid site url address'
            ]
        },
        textEnum() {
            return LinkTypes.Text;
        },
        couponEnum(){
            return LinkTypes.Coupon;
        },
        extSiteLink() {
            return LinkTypes.ExtLink;
        },
        companySiteEnum() {
            return LinkTypes.SiteLink;
        },
        canSubmit(){
            return this.chosenAction !== LinkTypes.None;
        }
    }
}
</script>
